@if (report$ != null) {
}
@if (report$ | async; as rep) {
  <mat-icon class="favorite" (click)="setFavorite(rep, $event)"
    [matTooltip]="rep.favorite ? 'Remove favorite' : 'Add favorites'">
    {{ rep.favorite == true ? "bookmark" : "bookmark_outline" }}
  </mat-icon>
}